// Sidebar items
const menuItems = [

  {
    icon: 'fas fa-chart-bar fa-2x',
    to: '/dashboard',
    name: 'Dashboard',
    selected: false,
  },
  {
    icon: 'fas fa-file-alt fa-2x',
    to: '/inventory',
    name: 'Inventory',
    selected: false,
  },

  {
    icon: 'fas fa-link fa-2x',
    to: '/integrations',
    name: 'Integrations',
    selected: false,
  },
  {
    icon: 'fas fa-users fa-2x',
    to: '/organisation',
    name: 'Organisation',
    selected: false,
  },
  {
    icon: 'fas fa-lightbulb fa-2x',
    to: '/recommendation',
    name: 'Recommendations',
    selected: false,
  },
  {
    icon: 'fa-solid fa-people-arrows-left-right',
    to: '/pact-network',
    name: 'Product Carbon Footprints',
    selected: false,
  },
  {
    icon: 'fa-solid fa-newspaper fa-2x',
    to: '/saved-reports',
    name: 'Saved Reports',
    selected: false,
  },
  {
    icon: 'fas fa-bell fa-2x',
    to: '#',
    name: 'Notifications',
    selected: false,
  },
];

export default menuItems;
